import Vue from 'vue';
import Router from 'vue-router';
import HomePage from '@/views/HomeView.vue';
import Package from '@/views/PackageDetailedView.vue';
import PackageForm from '@/views/PackageFormView.vue';
import CheckOutView from '@/views/CheckOutView.vue';
import Success from '@/views/SuccessView.vue';
import Failure from '@/views/FailureView.vue';
import PaywaitScreen from '@/views/PaywaitScreen.vue';
import NotFound from '@/views/NotFound.vue'; // 👈 import your 404 page
import AboutUsView from '@/views/AboutUsView.vue';
Vue.use(Router);

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'Home',
      component: HomePage,
    },
    {
      path: '/Package/:id',
      name: 'Package',
      component: Package,
      props: true,
    },
    {
      path: '/PackageForm/:planId',
      name: 'PackageForm',
      component: PackageForm,
      props: true,
    },
    {
      path: '/CheckOut',
      name: 'CheckOut',
      component: CheckOutView,
    },
    {
      path: '/PaywaitScreen',
      name: 'PaywaitScreen',
      component: PaywaitScreen,
    },
    {
      path: '/Success',
      name: 'Success',
      component: Success,
    },
    {
      path: '/AboutUs',
      name: 'AboutUs',
      component: AboutUsView,
    },
    {
      path: '/Failure',
      name: 'Failure',
      component: Failure,
    },
    {
      path: '*',
      name: 'NotFound',
      component: NotFound,
    },
  ],
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    }
    return {
      x: 0,
      y: 0,
      behavior: 'smooth',
    };
  },
});
